import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "../../../components/common/ModalHeader";
import ModalFooter from "../../../components/common/ModalFooter";
import ModalBody from "../../../components/common/ModalBody";
import QrCodeScanner from "../../../components/common/QrCodeScanner";
import { Row, Col } from "react-bootstrap";
import ItemService from "../../../services/commonService";
import toast from "react-hot-toast";
import ConstantsList from "../../../common/Constants";
import PinAuthScreen from "../../common/PinAuthScreen/PinAuthScreen";

const LoginByQRCode = (props) => {
  let [qrOpen, setQROpen] = useState(false);
  let [pinOpen, setPinOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [userId, setUserId] = useState('');

  useEffect(() => {
    const deviceCode = localStorage.getItem("deviceCode");

    setQROpen(!!deviceCode); // true if exists, false if not
    setPinOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleClick = (decodedText) => {
    if (!decodedText) {
      toast.error("User ID cannot be empty!!", {
        duration: 3000,
        position: "top-right",
      });
      return;
    }
    setPinOpen(true);
    setQROpen(false);
    setUserId(decodedText);    
  };

  const handleSuccess = async (decodedText, decodedResult) => {
    // console.log(">>decodedText ", decodedText);
    if (decodedText) {
      handleClick(decodedText);
    }
  };

  const verifyPin = async (pin) => {
    if (isProcessing) return; // Prevent multiple calls while processing

    setIsProcessing(true); // Set processing lock
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      email: userId,
      loginType: "QR",
      deviceCode: localStorage.getItem("deviceCode") || "",
      pin: pin,
    };

    if (userId === "") {
      toast.error("User ID cannot be empty!!", {
        duration: 3000,
        position: "top-right",
      });
      setIsProcessing(false); // Reset lock if input is invalid
    } else {
      ItemService.login(obj)
        .then((item) => {
          console.log(">> item >>", item);
          if (item?.status === 200) {
            toast.success(item?.message || "User registered successfully", {
              duration: 2000,
              position: "top-right",
            });
            window.location = ConstantsList.HOME;
          } else {
            toast.error(item?.message || "Invalid input", {
              duration: 7000,
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          console.error("Login error:", error);
          toast.error("An error occurred, please try again", {
            duration: 4000,
            position: "top-right",
          });
        })
        .finally(() => {
          setIsProcessing(false); // Reset lock after completion
          toast.dismiss(toastId);
        });
    }
  };

  const { show, onHide } = props;
  return (
    <>
      <Modal
        show={show}
        size="lg"
        className="jobcard-qrscanner-modal"
        onHide={onHide}
        animation={false}
        backdrop="static"
      >
        <ModalHeader title={"Login By QR Code"}></ModalHeader>
        <ModalBody>

          <span
            className={
              localStorage.getItem("deviceCode")
                ? "device-code"
                : "device-not-configured"
            }
          >
            {localStorage.getItem("deviceCode") || "⚠ Device Not Configured"}
          </span>

          {qrOpen && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "90vh",
              }}
            >
              <div
                style={{
                  width: "80%",
                  height: "auto",
                  border: "2px solid black",
                  padding: "10px",
                }}
              >
                <QrCodeScanner
                  onSuccess={handleSuccess}
                  onError={props.handleError}
                  qrbox={{ width: 250, height: 250 }} // Reduced qrbox size
                />
              </div>
            </div>
          )}

          {pinOpen && (
            <PinAuthScreen
              onSubmitPin={verifyPin}
              onBack={() => {
                setPinOpen(false);
                setQROpen(true);
                setInputValue("");
              }}
            />
          )}
        </ModalBody>
        {qrOpen && (
          <ModalFooter>
            <Row>
              <Col xs={8} md={8}>
                <form className="manual-jobcard-form">
                  <label for="fname">User ID &nbsp;</label>
                  <input
                    type="text"
                    id="fname"
                    value={inputValue}
                    onChange={handleInputChange}
                    name="fname"
                  />
                </form>
              </Col>
              <Col xs={4} md={4}>
                <Button
                  type="button"
                  variant="success"
                  className="btn btn-success"
                  onClick={() => handleClick(inputValue)}
                >
                  {"SUBMIT"}
                </Button>
              </Col>
            </Row>
          </ModalFooter>
        )}
      </Modal>
    </>
  );
};

export default LoginByQRCode;
